/**
 * BEXI logo — a gradient "spark" mark (cyan→violet→green) with a small sparkle,
 * in the style of a modern AI assistant. Transparent background, so it sits on
 * the purple pill (FAB) or on light/dark surfaces (header, avatar) alike.
 */
export default function BexiLogo({
    size = 24, className = ''
}) {
    const gid = 'bexi-spark-grad';
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
            <defs>
                <linearGradient id={gid} x1="3" y1="21" x2="21" y2="3" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#7c3aed" />
                    <stop offset="0.55" stopColor="#22d3ee" />
                    <stop offset="1" stopColor="#4ade80" />
                </linearGradient>
            </defs>
            {/* Hollow triangular spark (evenodd cuts the inner triangle). */}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3.2 L20.8 19.6 H3.2 Z M12 8.9 L16.4 17 H7.6 Z"
                fill={`url(#${gid})`}
            />
            {/* Accent sparkle, top-right. */}
            <path
                d="M18.6 3.4c.24.98.66 1.4 1.64 1.64-.98.24-1.4.66-1.64 1.64-.24-.98-.66-1.4-1.64-1.64.98-.24 1.4-.66 1.64-1.64z"
                fill="#67e8f9"
            />
        </svg>
    );
}
